'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/booklist", "/booklist/list");
  $stateProvider
    .state('booklist', {
      url: '/booklist',
      template: require('./booklist.html'),
      authenticate: true
    })
    .state('booklist.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'BookListController',
      controllerAs: 'BListCtrl'
    })
    .state('booklist.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'BookListAddController',
      controllerAs: 'BListAddCtrl'
    })
    .state('booklist.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'BookListEditController',
      controllerAs: 'BListEditCtrl'
    })
    .state('booklist.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'BookListShowController',
      controllerAs: 'BListShowCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/booklist/booklist.routes.js